import { useToast } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import { useQuery } from '@tanstack/react-query';
import { getGroupMonitoringDataTableColumns } from './GroupMonitoringDataTableMeta';
import { getTerminalsMonitoringDataTableColumns } from './TerminalsMonitoringDataTableMeta';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import GabInformations from '@Modules/terminalManagementSystem/gabManagement/components/GabInformations';

const MonitoringDataTableHandler = () => {
  const toast = useToast();

  //   Initialize react Query to GET Data
  const groupMonitoringQueryKey = ['GroupMonitoring'];
  const { data: groupMonitoringData, isLoading } = useQuery({
    queryKey: groupMonitoringQueryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(
          () =>
            resolve([
              {
                primaryKey: 1,
                group: 'GROUPE LITTO-OUEST',
                inService: {
                  num: 0,
                  state: false,
                },
                outOfService: {
                  num: 1,
                  state: true,
                },
                offline: {
                  num: 0,
                  state: false,
                },
                supervised: {
                  num: 0,
                  state: false,
                },
              },
              {
                primaryKey: 2,
                group: 'GROUPE CENTRE-SEPT',
                inService: {
                  num: 0,
                  state: false,
                },
                outOfService: {
                  num: 0,
                  state: false,
                },
                offline: {
                  num: 0,
                  state: false,
                },
                supervised: {
                  num: 0,
                  state: false,
                },
              },
              {},
              {},
              {},
              {},
              {},
            ]),
          500
        );
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const terminalsMonitoringQueryKey = ['TerminalsMonitoring'];
  const {
    data: terminalsMonitoringData,
    isLoading: isTerminalsMonotoringLoading,
  } = useQuery({
    queryKey: terminalsMonitoringQueryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve([{primaryKey: '1', state: true, number: '110715019', name: 'TEST'}, {}, {}, {}, {}]), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const columnsTerminalsMonitoring = getTerminalsMonitoringDataTableColumns({
    isTerminalsMonotoringLoading,
  });

  const columnsGroupMonitoring = getGroupMonitoringDataTableColumns({
    isLoading,
  });

  return (
    <>
      <CC.SimpleGrid
        columns={{ base: 1, lg: 2 }}
        gridRowGap={4}
        columnGap={10}
        my={4}
      >
        <CC.Box>
          <CC.SimpleGrid columns={4} spacing={10} my={10}>
            <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
              <CC.Text fontWeight={'bold'}>En Service</CC.Text>
              <CC.Skeleton isLoaded={!isLoading}>
                <CC.Text
                  fontWeight={'bold'}
                  textAlign={'center'}
                  fontSize={'2xl'}
                >
                  <GabInformations numberOfGAB={0} status={false} />
                </CC.Text>
              </CC.Skeleton>
            </CC.Box>

            <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
              <CC.Text fontWeight={'bold'}>Hors Service</CC.Text>
              <CC.Skeleton isLoaded={!isLoading}>
                <CC.Text
                  fontWeight={'bold'}
                  textAlign={'center'}
                  fontSize={'2xl'}
                >
                  <GabInformations numberOfGAB={100} status={true} />
                </CC.Text>
              </CC.Skeleton>
            </CC.Box>

            <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
              <CC.Text fontWeight={'bold'}>Non Conn.</CC.Text>
              <CC.Skeleton isLoaded={!isLoading}>
                <CC.Text
                  fontWeight={'bold'}
                  textAlign={'center'}
                  fontSize={'2xl'}
                >
                  <GabInformations numberOfGAB={0} status={false} />
                </CC.Text>
              </CC.Skeleton>
            </CC.Box>

            <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
              <CC.Text fontWeight={'bold'}>Supervis.</CC.Text>
              <CC.Skeleton isLoaded={!isLoading}><CC.Text fontWeight={'bold'} textAlign={'center'} fontSize={'2xl'}>
                <GabInformations numberOfGAB={0} status={false} />
              </CC.Text></CC.Skeleton>
            </CC.Box>
          </CC.SimpleGrid>
          <CustomReactTable
            data={groupMonitoringData || [{}, {}, {}]}
            columns={columnsGroupMonitoring}
          />
        </CC.Box>

        <CustomFieldSet title="Teminals">
          <CustomReactTable
            data={terminalsMonitoringData || [{}, {}, {}]}
            columns={columnsTerminalsMonitoring}
          />
        </CustomFieldSet>
      </CC.SimpleGrid>
    </>
  );
};

export default MonitoringDataTableHandler;
